/* eslint-disable import/prefer-default-export */
import { concat } from 'ramda';
import { loadingManagementApi } from 'feature/loading-management/loadingManagementApi';
import { createSingleAbortableQuery } from 'utils/helpers/abortPreviousRequest';

const getUrl = concat('authorization-sequencing/');

// Controller ref for cancelling previous auth sequence list requests
const authSequenceListController = { current: null };

const authorizationSequencingEndpoints = loadingManagementApi.injectEndpoints({
  endpoints: ({ mutation, query }) => ({
    getAuthSeqFilterLocationsList: query({
      query: params => ({
        params,
        url: getUrl('get-filter-locations-list'),
      }),
    }),
    getAuthSeqFilterProductsList: query({
      query: params => ({
        params,
        url: getUrl('get-filter-products-list'),
      }),
    }),
    getAuthSeqList: query({
      providesTags: ['AuthorizationSequencing'],
      queryFn: createSingleAbortableQuery(
        authSequenceListController,
        async (params, api, extraOptions, baseQuery, signal) => {
          return baseQuery(
            {
              params,
              signal,
              url: getUrl('view-authorization-sequencing'),
            },
            api,
            extraOptions
          );
        }
      ),
    }),
    updateAuthorizationSequencing: mutation({
      query: body => ({
        body,
        method: 'POST',
        url: getUrl('edit'),
      }),
    }),
  }),
});

export const {
  useGetAuthSeqFilterLocationsListQuery,
  useGetAuthSeqFilterProductsListQuery,
  useGetAuthSeqListQuery,
  useUpdateAuthorizationSequencingMutation,
} = authorizationSequencingEndpoints;
